import { Box, Typography } from '@sbv-clients/ui-shared';

import SharedAuthLayout from '../../layouts/shared-auth-layout';
import { RegisterProvider } from './providers/register.provider';
import { RegisterForm } from './register-form';

export const SharedRegisterPage = () => {
  return (
    <RegisterProvider>
      <SharedAuthLayout>
        <Box mb={6} textAlign="center">
          <Typography variant="h1" fontWeight={700} mb={2}>
            Welcome!
          </Typography>
          <Typography>
            Let’s get your account set up. Please choose a new username and
            password.
          </Typography>
        </Box>
        <RegisterForm />
      </SharedAuthLayout>
    </RegisterProvider>
  );
};
